import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ConnectedList } from '@/Domain/components/Shared/ConnectedList/ConnectedList';
import { Label } from '@/Domain/components/Shared/Label/Label';
import { Snippet } from '@/Domain/components/Shared/Snippet/Snippet';
import { ActionHelper } from '@/Domain/helper/Action.helper';
import { useMcpForm } from '@/Domain/hooks/Action/useMcpForm/useMcpForm';

/** Connect-MCP dialog body: the hosted URL plus per-client add steps. */
export const McpConnectInstructions = () => {
  const { t } = useTranslation('mcp_page');

  const { data } = useMcpForm();

  const url = ActionHelper.generateRemoteMcpUrl();
  const isPrivate = data?.visibility === 'private';

  const connectSteps = useMemo(
    () => [
      t('integration.steps.claude'),
      t('integration.steps.cursor'),
      t('integration.steps.chatgpt'),
    ],
    [t],
  );

  return (
    <div className="flex flex-col gap-4">
      <section>
        <Label>{t('integration.url.title')}</Label>
        <p className="mt-1 mb-2 text-sm text-foreground-subtle">
          {t('integration.url.description')}
        </p>
        <Snippet code={url} />
      </section>

      <section>
        <Label>{t('integration.steps.title')}</Label>
        <ConnectedList items={connectSteps} className="mt-3" />
        {isPrivate && (
          <p className="mt-2 text-sm text-foreground-subtle">{t('integration.private_note')}</p>
        )}
      </section>
    </div>
  );
};
